export function calculateDiffPercent(currentValue, opponentValue) {
  if (!currentValue && opponentValue) {
    return 100;
  } else if (!currentValue && !opponentValue) {
    return 0;
  } else {
    currentValue = currentValue || 1;
    return Number(((opponentValue * 100 / currentValue) - 100).toFixed());
  }
}

export function parseStatSymbol(statName, types) {
  const type = types[statName];

  switch (type) {
    case 'percent':
      return `%`;

    default:
      return '';
  }
}
